import React, { useMemo } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useQuery } from "@tanstack/react-query";
import { GetUserAgeGroupCount } from "../../../Api/report";
import { ErrorToast } from "../../../Utils/SweetAlert";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const UserAgeGroupTab = () => {
    const { data: reportData, isFetching: loading } = useQuery({
        queryKey: ["get-user-age-group-count"],
        queryFn: () => GetUserAgeGroupCount(),
        throwOnError: (error) => {
            ErrorToast(error?.response?.data?.message || "Server Error.");
        },
    });

    const data = reportData?.data || [];

    const chartData = useMemo(() => {
        return {
            labels: data.map(item => item.label),
            datasets: [
                {
                    label: "User Count",
                    data: data.map(item => item.count),
                    backgroundColor: "#AD5ADC",
                    borderRadius: 8,
                },
            ],
        };
    }, [data]);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom",
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    precision: 0
                }
            },
        },
    };

    return (
        <div className="reports-tab-content">
            <div className="card flex-fill border-card mb-3 mt-3">
                <div className="card-header dashboard-chat-heading p-2">
                    <h5 className="card-title text-black fw-bold fs-4 pl-2">User Age Group Overview</h5>
                </div>
                <div className="card-body" style={{ height: '60vh' }}>
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="spinner-border loader-theme" role="status" />
                        </div>
                    ) : (
                        <Bar options={options} data={chartData} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserAgeGroupTab;
